import PropTypes from 'prop-types';
import React from 'react';

import FolderSelector, {DEFAULT_PROJECT_FOLDER_LABEL_TEXT} from 'file-browser/FolderSelector';
import {ButtonSize} from 'ui-library/buttons/Button';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {GenericEvent, Optional} from 'util/Types';

export default function ProjectFolderField({
  folderId,
  labelStyle,
  onChange,
  isRequired,
}: {
  folderId: Optional<string>;
  labelStyle: string;
  onChange: (e: GenericEvent) => void;
  isRequired: boolean;
}): JSX.Element {
  const allowNone = !isRequired;
  return (
    <div>
      <FieldLabel label={DEFAULT_PROJECT_FOLDER_LABEL_TEXT} labelStyle={labelStyle} isRequired={isRequired} />
      <FolderSelector
        buttonSize={ButtonSize.MEDIUM}
        enableRedesign={true}
        allowNone={allowNone}
        noFolderText={allowNone ? 'None' : undefined}
        value={folderId}
        onChange={onChange}
        showInventory={true}
        showRegistries={false}
        unsetOnFetchFail={true}
      />
    </div>
  );
}

ProjectFolderField.propTypes = {
  folderId: PropTypes.string,
  labelStyle: PropTypes.oneOf(Object.values(FieldLabel.STYLES)),
  onChange: PropTypes.func.isRequired,
};
